import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Paper, Tooltip } from '@material-ui/core';
import Colours from '../../../../styles/colours';
import { IsEmpty, Trim } from '../../../../common/util';
import { Status } from '../../../../common/constants';
import PostAction from '../../../../actions/post';
import AvailOutlets from './AvailOutlets';
import OtherLocations from './OtherLocations';
import postStyle from '../../../../styles/post';
import MText from '../../../../components/Common/MText';
import MTextField from '../../../../components/MTextField';

const Availability = (props) => {
  const [disableInputFields, setDisableInputFields] = useState(false);

  useEffect(() => {
    if (props && props.post) {
      const p = props.post;
      setDisableInputFields([Status.Live, Status.Paused].includes(p.currentPostStatus));
    }
  }, [props.post]);

  return (
    <>
      <Paper variant="elevation" className="px-5" style={postStyle.paper}>
        <MText text="Online Purchase URL" className="mt-3 mb-2" style={postStyle.textHeader} />

        <Tooltip
          title={disableInputFields ? `Cannot be updated because post is ${props.post.currentPostStatus}` : ''}
          isLink
        >
          <MTextField
            className=" w-100"
            placeholder="Must start with https://"
            multiline={false}
            value={props.post.promoAvailOnlineAt || ''}
            onChange={(text) => props.dispatchPostUpdate({ promoAvailOnlineAt: Trim(text, true) })}
            disabled={disableInputFields}
          />
        </Tooltip>
        {
          props.post.promoAvailOnlineAt && !IsEmpty(props.post.promoAvailOnlineAt) && !String(props.post.promoAvailOnlineAt).startsWith('https://')
          && <MText className="mt-1 ml-1" colour={Colours.Red}> *Url must start with 'https://'</MText>
        }

        <MText className="mt-4 mb-2" style={postStyle.textHeader}>
          Available in Outlets
          {disableInputFields && (
            <>
              <br />
              <small className="mb-2 d-block" style={{ color: '#ff9100', fontSize: 12 }}>{`Cannot be updated because post is ${props.post.currentPostStatus}`}</small>
            </>
          )}
        </MText>

        <AvailOutlets className="pb-3" disabled={disableInputFields} disabledMsg={`Cannot be updated because post is ${props.post.currentPostStatus}`} />

        <OtherLocations className="mt-3 mb-4" disabled={disableInputFields} disabledMsg={`Cannot be updated because post is ${props.post.currentPostStatus}`} />
      </Paper>
    </>
  );
};

Availability.propTypes = {
  dispatchPostUpdate: PropTypes.func.isRequired,
  post:               PropTypes.shape({
    promoAvailOnlineAt: PropTypes.string,
    currentPostStatus:  PropTypes.string,
  }).isRequired,
};

Availability.defaultProps = {

};

const mapStateToProps = (state) => ({
  post: state.post.selected,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchPostUpdate: (post) => PostAction.postDataUpdate(dispatch, post),
});

export default connect(mapStateToProps, mapDispatchToProps)(Availability);
